// Run yarn update-openapi-specs to pull down the latest status codes from application service
// into status.openapi3.ts. You must have GITHUB_TOKEN defined as an environment variable before
// running.

import statusCodeJson from './openApiSpecs/status.openapi3';

export type ApplicationStatusCode =
  keyof typeof statusCodeJson.components.schemas;

const statusCodes = Object.keys(
  statusCodeJson.components.schemas
) as ApplicationStatusCode[];

export const APPLICATION_STATUS_CODES = statusCodes.reduce<
  Record<ApplicationStatusCode, string>
>((statusCodesObj, key) => {
  const enumValue = statusCodeJson.components.schemas[key].enum?.[0];
  if (enumValue) {
    statusCodesObj[key] = enumValue;
  }
  return statusCodesObj;
}, {} as Record<ApplicationStatusCode, string>);
